import { useEffect } from 'react'
import { History, RefreshCw } from 'lucide-react'
import { api } from '../api/client'
import { DataTable } from '../components/DataTable'
import { Button, Card, ErrorState, LoadingBlock, PageHeader } from '../components/ui'
import { useAsync } from '../lib/useAsync'

export function AuditPage() {
  const audit = useAsync(() => api.audit(2000), [])

  useEffect(() => {
    const refresh = () => void audit.run()
    window.addEventListener('dcs:refresh', refresh)
    return () => window.removeEventListener('dcs:refresh', refresh)
  }, [audit.run])

  if (audit.loading && !audit.data) return <LoadingBlock label="Читаем журнал изменений…" />
  if (audit.error && !audit.data) return <ErrorState error={audit.error} onRetry={() => void audit.run()} />

  const rows = audit.data || []
  return <div className="page audit-page">
    <PageHeader
      title="Журнал изменений"
      subtitle="Неизменяемый след операций с реестром: кто, что и когда менял"
      actions={<Button variant="primary" onClick={() => void audit.run()} disabled={audit.loading}>
        <RefreshCw size={16} className={audit.loading ? 'spin' : ''} /> Обновить
      </Button>}
    />
    <Card>
      <div className="card-head">
        <div><span className="eyebrow">Audit trail</span><h2>{rows.length} последних событий</h2></div>
        <div className="audit-hint"><History size={16}/> Журнал доступен только для чтения</div>
      </div>
      <DataTable
        rows={rows}
        columns={['audit_id', 'created_at', 'actor', 'action', 'table_name', 'record_id', 'payload_json']}
        rowKey={row => String(row.audit_id)}
        maxHeight="calc(100vh - 280px)"
      />
    </Card>
  </div>
}
